const messages = {
    en: {
        role: {
            role: "role",
            roles: "roles",
            title: 'Roles management',
            description: 'View, search, create, edit and delete roles',
            deleteTitle: 'Deleting role',
            createTitle: 'Creating role',
            updateTitle: 'Updating role',
            created: 'Role created',
            updated: 'Role updated',
            deleted: 'Role deleted',
            showTitle: 'Roles and Permissions',
            permission: 'Permission',
            rolDuplicate: 'Duplicated Role',
            label: {
                name: "Name",
                childRoles: "Child Roles",
                permissions: "Permissions"
            },
            permissions: {
                SECURITY_USER_CREATE: 'User creation',
                SECURITY_USER_EDIT: 'User edition',
                SECURITY_USER_DELETE: 'User deletion',
                SECURITY_USER_SHOW: 'User display',
                SECURITY_GROUP_CREATE: 'Group creation',
                SECURITY_GROUP_EDIT: 'Group Edition',
                SECURITY_GROUP_DELETE: 'Group deletion',
                SECURITY_GROUP_SHOW: 'Group display',
                SECURITY_ROLE_SHOW: 'Role display',
                SECURITY_ROLE_SHOW_CHILD: 'Child role display',
                SECURITY_ROLE_CREATE: 'Role creation',
                SECURITY_ROLE_EDIT: 'Role edition',
                SECURITY_ROLE_DELETE: 'Role deletion',
                SECURITY_DASHBOARD_SHOW: 'Show admin dashboard',
                SECURITY_ADMIN_MENU: 'Show admin menu',
                ENVIRONMENTVARIABLE_SHOW:"Environment variables show",
                ENVIRONMENTVARIABLE_UPDATE:"Environment variables edition",
                ENVIRONMENTVARIABLE_CREATE:"Environment variables creation",
                ENVIRONMENTVARIABLE_DELETE:"Environment variables deletion",
                CAMPAIGN_CREATE:"Campaign creation",
                CAMPAIGN_SHOW:"Campaign display",
                CAMPAIGN_UPDATE:"Campaign edition",
                CAMPAIGN_DELETE:"Campaign deletion",
                CUSTOMFIELDS_SHOW:"Custom fields display",
                CUSTOMFIELDS_UPDATE:"Custom fields edition",
                CUSTOMFIELDS_CREATE:"Custom fields creation",
                CUSTOMFIELDS_DELETE:"Custom fields deletion",
                PERSON_SHOW:"Person display",
                PERSON_UPDATE:"Person edition",
                PERSON_DELETE:"Person deletion",
                PERSON_CREATE:"Person creation",
                IMPORT_CSV:"Import CSV",
                SOCIOECONOMICLEVEL_UPDATE:"Socioeconomic level edition",
                SOCIOECONOMICLEVEL_CREATE:"Socioeconomic level creation",
                LIVINGPLACETYPE_UPDATE:"Living place type edition",
                SOCIOECONOMICLEVEL_DELETE:"Socioeconomic level deletion",
                LIVINGPLACETYPE_CREATE:"Living place type creation",
                LIVINGPLACETYPE_DELETE:"Living place type deletion",
                CATEGORYCOMPANY_SHOW:"Category company display",
                CATEGORYCOMPANY_CREATE:"Category company creation",
                CATEGORYCOMPANY_DELETE:"Category company deletion",
                CATEGORYCOMPANY_UPDATE:"Category company edition",
                COMPANY_CREATE:"Company creation",
                COMPANY_DELETE:"Company deletion",
                COMPANY_UPDATE:"Company edition",
                COMPANY_SHOW:"Company display",
                MT_SMS_BY_CMP:"MT by CMP",
                INTERACTIONS_EXPORT: "Export interactions",
                CAMPAIGN_EXPORT: "Export campaigns",
                CAMPAIGN_UPLOADAUDIO: "Upload campaign audio",
                SHOW_MULTICHANNEL_MSG: "Multichannel message display",
                REDMINE_SHOW: "Redmine ticket display",
                REDMINE_CREATE: "Redmine ticket create",
                PERSONS_EXPORT: "Export people",
                SOCIOECONOMICLEVEL_SHOW: "Socioeconomic level display",
                LIVINGPLACETYPE_SHOW: "Living place type display",
                COMPANY_EXPORT: "Export companies",
                REDMINE_UPDATE:"Redmine Update",
                REDMINE_DELETE:"Redmine Delete",
                AUDIT_CREATE:"Audit create",
                AUDIT_MENU: "Audits menu display",
                AUDIT_SHOW:"Audit display"
            }
        },
    },
    es: {
        role: {
            role: "rol",
            roles: "roles",
            title: 'Administración de Roles',
            description: 'Ver, buscar, crear, editar, y borrar roles del sistema',
            deleteTitle: 'Borrando role',
            createTitle: 'Creando rol',
            updateTitle: 'Editando rol',
            created: 'Rol creado',
            updated: 'Rol actualizado',
            deleted: 'Rol eliminado',
            showTitle: 'Roles y Permisos',
            permission: 'Permiso',
            rolDuplicate: 'Rol ya Existente',
            label: {
                name: "Nombre",
                childRoles: "Roles hijos",
                permissions: "Permisos"
            },
            permissions: {
                SECURITY_USER_CREATE: 'Creación de usuarios',
                SECURITY_USER_EDIT: 'Edición de usuarios',
                SECURITY_USER_DELETE: 'Eliminación de usuarios',
                SECURITY_USER_SHOW: 'Visualización de usuarios',
                SECURITY_GROUP_CREATE: 'Creación de grupos',
                SECURITY_GROUP_EDIT: 'Edición de grupos',
                SECURITY_GROUP_DELETE: 'Eliminación de grupos',
                SECURITY_GROUP_SHOW: 'Visualización de grupos',
                SECURITY_ROLE_SHOW: 'Visualización de roles',
                SECURITY_ROLE_SHOW_CHILD: 'Visualización de roles hijos',
                SECURITY_ROLE_CREATE: 'Creación de roles',
                SECURITY_ROLE_EDIT: 'Edición de roles',
                SECURITY_ROLE_DELETE: 'Eliminación de roles',
                SECURITY_DASHBOARD_SHOW: 'Visualización de panel de administración',
                SECURITY_ADMIN_MENU: 'Visualización de menu de administración',
                ENVIRONMENTVARIABLE_SHOW:"Visualización de variables de entorno",
                ENVIRONMENTVARIABLE_UPDATE:"Edición de variables de entorno",
                ENVIRONMENTVARIABLE_CREATE:"Creación de variables de entorno",
                ENVIRONMENTVARIABLE_DELETE:"Eliminación de variables de entorno",
                CAMPAIGN_CREATE:"Creación de campañas",
                CAMPAIGN_SHOW:"Visualización de campañas",
                CAMPAIGN_UPDATE:"Edición de campañas",
                CAMPAIGN_DELETE:"Eliminación de campañas",
                CUSTOMFIELDS_SHOW:"Visualización de campos personalizables",
                CUSTOMFIELDS_UPDATE:"Edición de campos personalizables",
                CUSTOMFIELDS_CREATE:"Creación de campos personalizables",
                CUSTOMFIELDS_DELETE:"Eliminación de campos personalizables",
                PERSON_SHOW:"Visualización de personas",
                PERSON_UPDATE:"Edición de personas",
                PERSON_DELETE:"Eliminación de personas",
                PERSON_CREATE:"Creación de personas",
                IMPORT_CSV:"Importar CSV",
                SOCIOECONOMICLEVEL_UPDATE:"Edición de nivel socioeconomico",
                SOCIOECONOMICLEVEL_CREATE:"Creación de nivel socioeconomico",
                LIVINGPLACETYPE_UPDATE:"Edición de tipo de vivienda",
                SOCIOECONOMICLEVEL_DELETE:"Eliminación de nivel socioeconomico",
                LIVINGPLACETYPE_CREATE:"Creación de tipo de vivienda",
                LIVINGPLACETYPE_DELETE:"Eliminación de tipo de vivienda",
                CATEGORYCOMPANY_SHOW:"Visualización de categorias de empresa",
                CATEGORYCOMPANY_CREATE:"Creación de categorias de empresa",
                CATEGORYCOMPANY_DELETE:"Eliminación de categorias de empresa",
                CATEGORYCOMPANY_UPDATE:"Edición de categorias de empresa",
                COMPANY_CREATE:"Creación de empresas",
                COMPANY_DELETE:"Eliminación de empresas",
                COMPANY_UPDATE:"Edición de empresas",
                COMPANY_SHOW:"Visualización de empresas",
                MT_SMS_BY_CMP:"MT por CMP",
                INTERACTIONS_EXPORT: "Exportar interacciones",
                CAMPAIGN_EXPORT: "Exportar campañas",
                CAMPAIGN_UPLOADAUDIO: "Cargar audio de campaña",
                SHOW_MULTICHANNEL_MSG: "Visualización mensaje Multichannel",
                REDMINE_SHOW: "Visualización tickets Redmine",
                REDMINE_CREATE: "Creacion tickets Redmine",
                PERSONS_EXPORT: "Exportar personas",
                SOCIOECONOMICLEVEL_SHOW: "Visualización nivel socioeconomico",
                LIVINGPLACETYPE_SHOW: "Visualización tipo de vivienda",
                COMPANY_EXPORT: "Exportar empresas",
                REDMINE_UPDATE:"Edición de Redmine",
                REDMINE_DELETE:"Eliminación de Redmine",
                AUDIT_CREATE:"Creación de Auditoria",
                AUDIT_MENU: "Visualizacion de menu de auditorias",
                AUDIT_SHOW:"Visualización de Auditoria"
            }
        },

    },
    pt: {
        role: {
            role: "rol",
            roles: "roles",
            title: 'Administração de função',
            description: 'Ver, buscar, criar, editar e usar função del sistema',
            deleteTitle: 'Eliminar role',
            createTitle: 'Criando função',
            updateTitle: 'Atualizando função',
            created: 'Função criado',
            updated: 'Função atualizado',
            deleted: 'Função removido',
            showTitle: 'Funções e Permissões',
            permission: 'Permissão',
            rolDuplicate: 'Função duplicada',
            label: {
                name: "Nome",
                childRoles: "Funções filhas",
                permissions: "Permissões"
            },
            permissions: {
                SECURITY_USER_CREATE: 'Criação do usuário',
                SECURITY_USER_EDIT: 'Edição do usuário',
                SECURITY_USER_DELETE: 'exclusão do usuário',
                SECURITY_USER_SHOW: 'Visualização do usuário',
                SECURITY_GROUP_CREATE: 'Criação em grupos',
                SECURITY_GROUP_EDIT: 'Edição em grupos',
                SECURITY_GROUP_DELETE: 'Exclusão em grupos',
                SECURITY_GROUP_SHOW: 'Visualização em grupos',
                SECURITY_ROLE_SHOW: 'Visualização de roles',
                SECURITY_ROLE_SHOW_CHILD: 'Visualização de roles crianças',
                SECURITY_ROLE_CREATE: 'Criação de roles',
                SECURITY_ROLE_EDIT: 'Edição de roles',
                SECURITY_ROLE_DELETE: 'Exclusão de roles',
                SECURITY_DASHBOARD_SHOW: 'Visor do painel de segurança',
                SECURITY_ADMIN_MENU: 'Visor do menu de segurança',
                ENVIRONMENTVARIABLE_SHOW:"Visor do Variáveis ​​ambientais",
                ENVIRONMENTVARIABLE_UPDATE:"Edição em Variáveis ​​ambientais",
                ENVIRONMENTVARIABLE_CREATE:"Criação em Variáveis ​​ambientais",
                ENVIRONMENTVARIABLE_DELETE:"Exclusão em Variáveis ​​ambientais",
                CAMPAIGN_CREATE:"Criação em Campanha",
                CAMPAIGN_SHOW:"Visor do Campanha",
                CAMPAIGN_UPDATE:"Edição em Campanha",
                CAMPAIGN_DELETE:"Exclusão em Campanha",
                CUSTOMFIELDS_SHOW:"Visor do Campo customizado",
                CUSTOMFIELDS_UPDATE:"Edição em Campo customizado",
                CUSTOMFIELDS_CREATE:"Criação em Campo customizado",
                CUSTOMFIELDS_DELETE:"Exclusão em Campo customizado",
                PERSON_SHOW:"Visor do pessoa",
                PERSON_UPDATE:"Edição em pessoa",
                PERSON_DELETE:"Exclusão em pessoa",
                PERSON_CREATE:"Criação em pessoa",
                IMPORT_CSV:"Importar CSV",
                SOCIOECONOMICLEVEL_UPDATE:"Edição em nível socioeconômico",
                SOCIOECONOMICLEVEL_CREATE:"Criação em nível socioeconômico",
                LIVINGPLACETYPE_UPDATE:"Edição em tipo de moradia",
                SOCIOECONOMICLEVEL_DELETE:"Exclusão em nível socioeconômico",
                LIVINGPLACETYPE_CREATE:"Criação em tipo de moradia",
                LIVINGPLACETYPE_DELETE:"Exclusão em tipo de moradia",
                CATEGORYCOMPANY_SHOW:"Visor do categoria empresa",
                CATEGORYCOMPANY_CREATE:"Criação em categoria empresa",
                CATEGORYCOMPANY_DELETE:"Exclusão em categoria empresa",
                CATEGORYCOMPANY_UPDATE:"Edição em categoria empresa",
                COMPANY_CREATE:"Criação em empresa",
                COMPANY_DELETE:"Exclusão em empresa",
                COMPANY_UPDATE:"Edição em empresa",
                COMPANY_SHOW:"Visor do empresa",
                MT_SMS_BY_CMP:"MT por CMP",
                INTERACTIONS_EXPORT: "Exportar interações",
                CAMPAIGN_EXPORT: "Exportar campanhas",
                CAMPAIGN_UPLOADAUDIO: "Carregar áudio da campanha",
                SHOW_MULTICHANNEL_MSG: "Exibição de mensagem Multichannel",
                REDMINE_SHOW: "Visor de tíquetes do Redmine",
                REDMINE_CREATE: "Criação de tíquete Redmine",
                PERSONS_EXPORT: "Exportar pessoa",
                SOCIOECONOMICLEVEL_SHOW: "Visor de nível socioeconômico",
                LIVINGPLACETYPE_SHOW: "Exibição do tipo de moradia",
                COMPANY_EXPORT: "Exportar empresas",
                REDMINE_UPDATE:"Edição do Redmine",
                REDMINE_DELETE:"Exclusão do Redmine",
                AUDIT_CREATE:"Criação de Auditoria",
                AUDIT_MENU: "Exibição do menu de auditoria",
                AUDIT_SHOW:"Visor de Auditoria"
                }
            }
        },

}

export default messages
